export const MinusIcon = () => {
    return (
        <svg viewBox="0 0 250 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M225 25H125H25" stroke="#1C274C" strokeWidth="50" strokeLinecap="round"/>
        </svg>
    );
}